//#endregion
//#region src/index.ts
var e = {
	messages: {
		en: { testreportGenerator: {
			title: "Generate Testreport",
			openButton: "Open Testreport Generator",
			selectAuthors: "Select Authors",
			openConfigurator: "Open Configurator",
			articleGenerated: "Article successfully generated"
		} },
		de: { testreportGenerator: {
			title: "Testreport generieren",
			openButton: "Testreport Generator öffnen",
			selectAuthors: "Autoren auswählen",
			openConfigurator: "Konfigurator öffnen",
			articleGenerated: "Artikel erfolgreich generiert"
		} }
	},
	routes: [{
		path: "/testreport-generator",
		children: [{
			path: "",
			name: "testreport_generator_entrypoint",
			component: () => import("./testreport-generator-entrypoint.view-B7NapAPE.js"),
			meta: { requiredRight: "testreport-generator:navigate" }
		}]
	}],
	contentBlocks: []
};
//#endregion
export { e as testreportGeneratorModule };

//# sourceMappingURL=index.es.js.map